import { Button, Form, Modal, PoweredBy } from '@/components';
import { defaultTheme } from '@/config';
import { sessionAPI } from '@/libs/api';
import { useForm } from '@/libs/hooks';
import { appStore, useAppStore } from '@/store';
import { FC, memo, useCallback, useState } from 'react';
import { Message } from './Message';
import { ButtonSubmit, Container, Divider } from './styles';
import { initialErrors, initialValues, validateForm } from './validation';

const UserSignedIn: FC = () => {
  const [isModal, setModal] = useState(false);
  const { token } = useAppStore();

  const handleFormSubmit = useCallback(
    async (value: typeof initialValues) => {
      if (value) {
        try {
          const session_token = token ?? '';
          await sessionAPI.claimSession(
            {
              user_ref: value.phoneNumber,
              name: value.name,
            },
            session_token,
          );
          // eslint-disable-next-line no-empty
        } catch (error) {
        } finally {
          appStore.setUser(value.name, value.phoneNumber);
          appStore.setActiveScreen('OTP_VERIFICATION');
        }
      }
    },
    [token],
  );

  const { values, errors, handleSubmit, handleChange } = useForm({
    initialValues,
    initialErrors,
    validate: validateForm,
    onSuccess: handleFormSubmit,
  });

  const handleGetStarted = useCallback(async () => {
    try {
      const { success, data } = await sessionAPI.claimGuestSession(token!);
      if (success && data?.token) {
        appStore.setToken(data.token);

        await new Promise((resolve) => setTimeout(resolve, 2000));
        appStore.setActiveScreen('CONVERSATION');
      }
    } catch (error) {
      console.log(error);
    }
  }, [token]);

  return (
    <Container>
      <Message />
      <form onSubmit={handleSubmit}>
        <Form.Item
          uiStyle="mui"
          labelProps={{ labelText: 'Name' }}
          inputProps={{
            type: 'text',
            name: 'name',
            placeholder: 'Enter your phone number',
            value: values.name,
            onChange: handleChange,
          }}
          variant={errors.name ? 'danger' : undefined}
          message={errors.name}
        />
        <Form.Item
          uiStyle="mui"
          labelProps={{ labelText: 'Phone Number. Ex. 017XXXXXXXX' }}
          inputProps={{
            type: 'tel',
            placeholder: 'Enter your phone number',
            name: 'phoneNumber',
            maxLength: 11,
            value: values.phoneNumber,
            onChange: handleChange,
          }}
          variant={errors.phoneNumber ? 'danger' : undefined}
          message={errors.phoneNumber}
        />
        <p>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setModal(true);
            }}
          >
            Terms & Conditions of Live Chat services
          </a>
        </p>
        <Modal isOpen={isModal} onClose={() => setModal(false)}>
          <Modal.Text style={{ color: defaultTheme.colors.black, textAlign: 'justify' }}>
            By clicking the Chat services, Visitors/Users agree to the terms & conditions for using this digital
            platform. Respective visitors/users are solely responsible for the content of their posted messages, and are
            giving Grameenphone the authority to engage on their behalf to try and resolve their queries/concerns over
            this digital platform as long as it relates to their authentic Grameenphone number.
          </Modal.Text>
          <Modal.ButtonGroup>
            <Button type="button" size="sm" variant="white" onClick={() => setModal(false)}>
              Close
            </Button>
          </Modal.ButtonGroup>
        </Modal>
        <ButtonSubmit type="submit" size="lg" block>
          Continue
        </ButtonSubmit>
        <Divider>
          <span>OR</span>
        </Divider>
        <ButtonSubmit type="button" size="lg" variant="light" block onClick={handleGetStarted}>
          Continue as guest
        </ButtonSubmit>
      </form>
      <PoweredBy style={{ margin: '40px 0 25px 0' }} />
    </Container>
  );
};

export default memo(UserSignedIn);
